import React from 'react';
import { CheckCircleTwoTone } from '@ant-design/icons';
import { Translate } from '@above-the-treeline/localization';
import './forgotPasswordSuccessMessage.less';

export default function ForgotPasswordSuccessMessage() {
	return (
		<div className="forgot-password-success-message">
			<CheckCircleTwoTone /> <Translate id="forgot_password_email_sent" />
		</div>
	);
}
